import 'css-chunksrc/client/common/secondaryCriteriaForm/numberForm/styles.scss';export default {
  "numberForm": "_numberForm_cgyfa_1",
  "input": "_input_cgyfa_5",
  "readOnly": "_readOnly_cgyfa_12",
  "disabled": "_disabled_cgyfa_19"
};